const setSecondChildrenCitizenIdExpireDate = (data = null,text = null) => {
  return {
    type: 'SET_SECONDCHILDRENCITIZENIDEXPIREDATE',
    data,
    text
  }
}

export default {
  setSecondChildrenCitizenIdExpireDate,
}
